module.exports = __webpack_public_path__ + "static/media/Annette-Baumgarten.4a291657.jpg";